var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgLock(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 21' }, props),
        React.createElement("path", { d: 'M8 .5c3.135 0 4.5 2.026 4.5 5.5a.5.5 0 11-1 0c0-2.986-1.02-4.5-3.5-4.5S4.5 3.014 4.5 6a.5.5 0 01-1 0C3.5 2.526 4.865.5 8 .5z' }),
        React.createElement("path", { d: 'M13 5.5H3A2.5 2.5 0 00.5 8v10A2.5 2.5 0 003 20.5h10a2.5 2.5 0 002.5-2.5V8A2.5 2.5 0 0013 5.5zm-10 1h10A1.5 1.5 0 0114.5 8v10a1.5 1.5 0 01-1.5 1.5H3A1.5 1.5 0 011.5 18V8A1.5 1.5 0 013 6.5z' }),
        React.createElement("path", { d: 'M8 10.528a.5.5 0 01.492.41l.008.09v3.87a.5.5 0 01-.992.09l-.008-.09v-3.87a.5.5 0 01.5-.5z' })));
}
export default SvgLock;
//# sourceMappingURL=Lock.js.map